/**
 * @module actions/calendarOverview
 */
import axios from 'axios'
import {
  API_URL
} from '../constants'

/**
 * @description Get capacity overview
 * @return {Promise} Axios promise
 */
export function getCapacityOverview (data) {
  let url = API_URL + '/CalendarOverview/Capacity'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get order timeline
 * @return {Promise} Axios promise
 */
export function getOrderTimeline (orderId, currentTime) {
  let url = API_URL + '/CalendarOverview/Capacity/Timeline/' + orderId + '?currentTime=' + currentTime.toJSON()
  return dispatch => {
    return axios.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/calendarOverview.js